export default __webpack_public_path__ + "static/logo.klepsch-62785c56f3251f0486abef53d411bffd.png";